import { MedewerkersOpStation } from "@/entities/medewerkers-op-station";
import { useGetStationDisplayName, useSortByStationDisplayName } from "@/entities/station";
import { Card, EmptyDescription, Separated } from "@/shared/components";
import { InzetVoorwaarden, Medewerkers } from "../shared";
import { MedewerkersStationLezen } from "./medewerkers-station-lezen";

type MedewerkersOpStationDetailsLezenProps = {
    aanvraag: MedewerkersOpStation[];
};

export function MedewerkersOpStationDetailsLezen({ aanvraag }: MedewerkersOpStationDetailsLezenProps) {
    const sortedStations = useSortByStationDisplayName(aanvraag);
    const relevantStations = sortedStations.filter((station) => station.status !== "NietAangevraagd" || station.mollen.length > 0);
    const getStationDisplayName = useGetStationDisplayName("withoutStationCode");

    if (relevantStations.length === 0) return <EmptyDescription>Geen medewerkers aangevraagd</EmptyDescription>;

    return (
        <>
            <InzetVoorwaarden className="mb-4" />
            <div className="mb-4 flex items-center justify-between font-medium">
                <h2>Betrokken stations</h2>
            </div>
            <Card className="mb-8 rounded-xl py-0">
                <ul>
                    <Separated>
                        {relevantStations.map((station) => {
                            const hasMedewerkers = [...station.vossen, ...station.mollen].length > 0;
                            return (
                                <li key={station.stationCode}>
                                    <MedewerkersStationLezen
                                        station={station}
                                        stationDisplayName={getStationDisplayName(station.stationCode)}
                                    />
                                    {hasMedewerkers && <Medewerkers vossen={station.vossen} mollen={station.mollen} />}
                                </li>
                            );
                        })}
                    </Separated>
                </ul>
            </Card>
        </>
    );
}
